import lozad from 'lozad';
import functions from './js/functions';

import './scss/style.scss';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import 'lightgallery/src/js/lightgallery.js';
import 'lightgallery/modules/lg-fullscreen.js';
import 'lightgallery/modules/lg-thumbnail.js';

import flatpickr from "flatpickr";
flatpickr.localize(flatpickr.l10ns[functions.getLang()]);
flatpickr.l10ns.default.firstDayOfWeek = 1;
import 'flatpickr/dist/l10n/sr.js';

import './js/components/gallery';
import './js/components/datepicker';
import './js/globals';
import './js/list';
import './js/details';
import './js/booking';
import './js/inquiry';
import './js/contact';

window.observer = lozad('.lozad', {
    rootMargin: '200px 0px',
    loaded: el => {
        $(el).triggerHandler('lozadLoaded');
    }
});
window.observer.observe();